import { render, staticRenderFns } from "./OrderOverviewModal.vue?vue&type=template&id=3fe0c4e7&"
import script from "./OrderOverviewModal.vue?vue&type=script&lang=js&"
export * from "./OrderOverviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports